<div class="content content-more-margin">
  @if (!showUSCountryPage() && !showLatamCountryPage()) {
    <div>
      <h1>{{ i18n.langString("terms_of_use_new_title") }}</h1>

      <h3>{{ i18n.langString("scope_1") }}</h3>
      <p [innerHTML]="i18n.langString('scope_1_1_content')"></p>
      <p [innerHTML]="i18n.langString('scope_1_2_content')"></p>
      <p [innerHTML]="i18n.langString('scope_1_3_content')"></p>

      <h3>{{ i18n.langString("scope_2") }}</h3>
      <p [innerHTML]="i18n.langString('scope_2_1_content')"></p>
      <p [innerHTML]="i18n.langString('scope_2_2_content')"></p>
      <p [innerHTML]="i18n.langString('scope_2_3_content')"></p>
      <p [innerHTML]="i18n.langString('scope_2_4_content')"></p>
      <p [innerHTML]="i18n.langString('scope_2_5_content')"></p>
      <p [innerHTML]="i18n.langString('scope_2_6_content')"></p>
      <p [innerHTML]="i18n.langString('scope_2_7_content')"></p>

      <h3>{{ i18n.langString("scope_3") }}</h3>
      <p [innerHTML]="i18n.langString('scope_3_1_content')"></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_1_a_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_1_b_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_1_c_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_1_d_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_1_e_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_1_f_content')"
      ></p>

      <p [innerHTML]="i18n.langString('scope_3_2_content')"></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_2_a_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_2_b_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_2_c_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_2_d_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_2_e_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_2_f_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_2_g_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_2_h_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_3_2_i_content')"
      ></p>

      <h3>{{ i18n.langString("scope_4") }}</h3>
      <p [innerHTML]="i18n.langString('scope_4_1_content')"></p>
      <p [innerHTML]="i18n.langString('scope_4_2_content')"></p>

      <h3>{{ i18n.langString("scope_5") }}</h3>
      <p [innerHTML]="i18n.langString('scope_5_1_content')"></p>
      <p [innerHTML]="i18n.langString('scope_5_2_content')"></p>
      <p [innerHTML]="i18n.langString('scope_5_3_content')"></p>

      <h3>{{ i18n.langString("scope_6") }}</h3>
      <p [innerHTML]="i18n.langString('scope_6_1_content')"></p>
      <p [innerHTML]="i18n.langString('scope_6_2_content')"></p>

      <h3>{{ i18n.langString("scope_7") }}</h3>
      <p [innerHTML]="i18n.langString('scope_7_1_content')"></p>
      <p [innerHTML]="i18n.langString('scope_7_2_content')"></p>
      <p [innerHTML]="i18n.langString('scope_7_3_content')"></p>
      <p [innerHTML]="i18n.langString('scope_7_4_content')"></p>
      <p [innerHTML]="i18n.langString('scope_7_5_content')"></p>

      <h3>{{ i18n.langString("scope_8") }}</h3>
      <p [innerHTML]="i18n.langString('scope_8_1_content')"></p>
      <p [innerHTML]="i18n.langString('scope_8_2_content')"></p>
      <p [innerHTML]="i18n.langString('scope_8_3_content')"></p>

      <h3>{{ i18n.langString("scope_9") }}</h3>
      <p [innerHTML]="i18n.langString('scope_9_1_content')"></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_9_1_a_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_9_1_b_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_9_1_c_content')"
      ></p>
      <p
        class="mar-left"
        [innerHTML]="i18n.langString('scope_9_1_d_content')"
      ></p>
      <p [innerHTML]="i18n.langString('scope_9_2_content')"></p>

      <h3>{{ i18n.langString("scope_10") }}</h3>
      <p [innerHTML]="i18n.langString('scope_10_1_content')"></p>
      <p [innerHTML]="i18n.langString('scope_10_2_content')"></p>
      <p [innerHTML]="i18n.langString('scope_10_3_content')"></p>
    </div>
  }

  @if (!showLatamCountryPage() && showUSCountryPage()) {
    <div>
      <h1>{{ i18n.langString("terms_of_use_new_title_latam") }}</h1>
      <!-- ✅ LATAM content unchanged, comments already removed -->
    </div>
  }

  @if (showUSCountryPage()) {
    <div>
      <h1>{{ i18n.langString("terms_of_use_title") }}</h1>
      <h3>{{ i18n.langString("terms_introduction") }}</h3>

      <p>{{ i18n.langString("terms_introduction_content_us") }}</p>
      <p>{{ i18n.langString("terms_introduction_content1") }}</p>
      <p>{{ i18n.langString("terms_introduction_content2_us") }}</p>
      <p>{{ i18n.langString("terms_introduction_content3") }}</p>

      <h3>{{ i18n.langString("via_loctite_pulse_app") }}</h3>
      <p>{{ i18n.langString("loctite_pulse_content") }}</p>

      <h4>{{ i18n.langString("loctite_pulse_function_title") }}</h4>

      <p>
        <span class="body-bold">{{
          i18n.langString("map_table_overview")
        }}</span>
        {{ i18n.langString("map_table_overview_content") }}
      </p>

      <p>
        <span class="body-bold">{{ i18n.langString("data_display") }}</span>
        {{ i18n.langString("data_display_content") }}
      </p>

      <p>
        <span class="body-bold">{{
          i18n.langString("maintenance_documentation")
        }}</span>
        {{ i18n.langString("maintenance_documentation_content") }}
      </p>

      <p>
        <span class="body-bold">{{
          i18n.langString("loctite_pulse_notifications")
        }}</span>
        {{ i18n.langString("loctite_pulse_notifications_content") }}
      </p>

      <p>
        <span class="body-bold">{{
          i18n.langString("push_notifications")
        }}</span>
        {{ i18n.langString("push_notifications_content") }}
      </p>

      <p>
        <span class="body-bold">{{
          i18n.langString("email_notifications")
        }}</span>
        {{ i18n.langString("email_notifications_content") }}
      </p>

      <p>
        <span class="body-bold">{{
          i18n.langString("installation_agent")
        }}</span>
        {{ i18n.langString("installation_agent_content") }}
      </p>

      <h3>{{ i18n.langString("general_terms_loctite_pulse_app") }}</h3>

      <h4>{{ i18n.langString("copyright_title") }}</h4>
      <p>{{ i18n.langString("copyright_content") }}</p>
      <p>{{ i18n.langString("copyright_content1_us") }}</p>
      <p>{{ i18n.langString("copyright_content2_us") }}</p>

      <h4>{{ i18n.langString("brands_title") }}</h4>
      <p>{{ i18n.langString("brands_content_us") }}</p>

      <h4>{{ i18n.langString("access_data_title") }}</h4>
      <p>{{ i18n.langString("access_data_content") }}</p>

      <h4>{{ i18n.langString("disclaimer_third_party_title") }}</h4>
      <p>{{ i18n.langString("disclaimer_third_party_content") }}</p>
      <p>{{ i18n.langString("disclaimer_third_party_content1_us") }}</p>
      <p>{{ i18n.langString("disclaimer_third_party_content2") }}</p>
      <p>{{ i18n.langString("disclaimer_third_party_content3") }}</p>

      <h4>{{ i18n.langString("disclaimer_title") }}</h4>
      <p>{{ i18n.langString("disclaimer_content_us") }}</p>
      <p>{{ i18n.langString("disclaimer_content1") }}</p>
      <p>{{ i18n.langString("disclaimer_content2") }}</p>
      <p>{{ i18n.langString("disclaimer_content3") }}</p>
      <p>{{ i18n.langString("disclaimer_content4_us") }}</p>
      <p>{{ i18n.langString("disclaimer_content5") }}</p>

      <h4>{{ i18n.langString("termination_loctite_pulse_app") }}</h4>
      <p>{{ i18n.langString("termination_loctite_pulse_content") }}</p>

      <h4>{{ i18n.langString("henkel_products") }}</h4>
      <p>{{ i18n.langString("henkel_products_content") }}</p>

      <h4>{{ i18n.langString("miscellaneous_title") }}</h4>
      <p>{{ i18n.langString("miscellaneous_content") }}</p>
    </div>
  }

  <app-nav-button
    [whiteBG]="true"
    tabindex="0"
    svgIcon="icons:arrow-left"
    (keyup)="gotoLogin()"
    (clickEvent)="gotoLogin()"
    >{{ i18n.langString("back") }}
  </app-nav-button>

  <app-scroll-to-top />
</div>
